import { render, staticRenderFns } from "./EstagiarioForm.vue?vue&type=template&id=ca05a20e"
import script from "./EstagiarioForm.vue?vue&type=script&lang=js"
export * from "./EstagiarioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports